import { createFileRoute } from '@tanstack/react-router';
import { FindUsSection } from '@/components/astro/new-design/sections/find-us';
import { HeroHeadingContactUs } from '@/components/astro/new-design/sections/hero-heading-contact-us';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import * as m from '@/paraglide/messages';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/contact-us')({
  head: () => ({
    meta: [
      ...seo({
        title: m.meta_contact_title(),
        description: m.meta_contact_description(),
      }),
    ],
    links: [...hreflangLinks('/contact-us')],
  }),
  component: () => (
    <>
      <NavBar />

      <HeroHeadingContactUs />
      <FindUsSection />

      <Footer />
    </>
  ),
});
